<template>
  <el-dialog
    :title="detailInfo.title"
    :visible.sync="detailInfo.showDia"
    v-if="detailInfo.showDia"
    :close-on-click-modal="false"
  >
    <div class="block">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in detailInfo.setps"
          :key="index"
          :icon="activity.icon"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
          :timestamp="
            activity.auditDate == null
              ? ''
              : activity.auditDate + '\u3000' + activity.auditContent
          "
        >
          {{ activity.auditUserName }}
        </el-timeline-item>
      </el-timeline>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="closeFrom()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
export default {
  components: { butn },
  props: ["detailInfo"],
  methods: {
    closeFrom() {
      this.$emit("closeDia", 1);
    }
  }
};
</script>
